import { format } from "date-fns";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { useTray } from "../context/TrayContext";

export const DatePicker = ({ light = false }) => {
  const { eventDate, setEventDate } = useTray();
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          data-testid="event-date-trigger"
          className={`flex w-full items-center justify-between gap-3 rounded-xl border-2 px-4 py-3 text-left font-body transition-colors ${
            light
              ? "border-nosh-cream/25 bg-transparent text-nosh-cream hover:border-nosh-gold"
              : "border-nosh-border bg-white text-nosh-ink hover:border-nosh-green"
          }`}
        >
          <span className="flex items-center gap-3">
            <CalendarDays className={`h-4 w-4 ${light ? "text-nosh-gold" : "text-nosh-green"}`} />
            {eventDate ? (
              <span className="font-medium">{format(eventDate, "EEE, MMM d, yyyy")}</span>
            ) : (
              <span className={light ? "text-nosh-cream/60" : "text-nosh-ink/45"}>Select your event date</span>
            )}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid="event-date-popover">
        <Calendar
          mode="single"
          selected={eventDate}
          onSelect={setEventDate}
          disabled={(date) => date < today}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};

export default DatePicker;
